import { useMutation } from "react-query";
import { Button, Container, Form, Grid, Input, Stack, Text } from "basis";
import { postBpayDetails } from "library/api";
import { validateBpayReferenceNumber } from "library/formValidation";
import { CreditCard } from "../CreditCard/CreditCard";
import { EVENTS } from "./bpayReducer";
import { BpayDetails } from "./BpayDetails";
import { parseBpayDetailsResponse } from "./validation";

function BpayForm({ state, dispatch }) {
  const { fromAccount, biller, referenceNumber, amount } = state;
  const { cardName, cardEndsWith } = fromAccount.data;
  const initialValues = {
    referenceNumber,
    amount,
    paymentDate: new Date(),
  };
  const postDetailsMutation = useMutation(postBpayDetails, {
    onSuccess: (response, variables) => {
      const responseData = parseBpayDetailsResponse(response.data);

      if (responseData === null) {
        dispatch({
          type: EVENTS.INVALID_RESPONSE,
        });
      } else {
        dispatch({
          type: EVENTS.DETAILS_VERIFIED_SUCCESSFULLY,
          referenceNumber: variables.referenceNumber,
          amount: variables.amount,
          paymentDate: variables.paymentDate,
          maskedMobileNumber: responseData.maskedMobileNumber,
          verifyOtpAction: responseData.verifyOtpAction,
          resendOtpAction: responseData.resendOtpAction,
        });
      }
    },
    onError: (error) => {
      const errorType = error.response?.data?.type ?? null;

      dispatch({
        type: EVENTS.DETAILS_VERIFICATION_FAILED,
        errorType,
      });
    },
  });
  const onSubmit = ({ errors, values }) => {
    if (Object.keys(errors).length === 0) {
      postDetailsMutation.mutate({
        billerCode: biller.code,
        referenceNumber: values.referenceNumber.replace(/\s/g, ""),
        amount: values.amount,
        paymentDate: values.paymentDate,
      });
    }
  };

  return (
    <Form initialValues={initialValues} onSubmit={onSubmit}>
      {({ state: { values } }) => (
        <Stack gap="8">
          <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="2">
            <Grid.Item colSpan="all" colSpan-sm="0-1">
              <Text>
                <strong>From account</strong>
              </Text>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="2-7">
              <Container bg="grey.t05" padding="4">
                <CreditCard cardName={cardName} cardEndsWith={cardEndsWith} />
              </Container>
            </Grid.Item>
          </Grid>
          <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="2">
            <Grid.Item colSpan="all" colSpan-sm="0-1">
              <Text>
                <strong>Pay to</strong>
              </Text>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="2-7">
              <BpayDetails biller={biller} paymentDate={values.paymentDate} />
            </Grid.Item>
          </Grid>
          <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="2">
            <Grid.Item colSpan="all" colSpan-sm="0-1">
              <Text>
                <strong>Payment details</strong>
              </Text>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="2-7">
              <Container bg="grey.t05" padding="4">
                <Stack gap="8">
                  <Input
                    name="referenceNumber"
                    label="Reference number"
                    variant="numeric"
                    validate={validateBpayReferenceNumber}
                  />
                  <Container width="100%" width-xs="50%">
                    <Input
                      name="amount"
                      label="Amount"
                      variant="decimal"
                      prefix="$"
                    />
                  </Container>
                </Stack>
              </Container>
            </Grid.Item>
          </Grid>
          <Grid cols="4" cols-sm="8" colsGap="30px" rowsGap="2">
            <Grid.Item colSpan="all" colSpan-sm="2-7">
              <Button
                type="submit"
                width="calc(50% - 16px)"
                width-xs="152"
                loading={postDetailsMutation.isLoading}
              >
                Next
              </Button>
              <Button
                variant="secondary"
                width="calc(50% - 16px)"
                width-xs="152"
                margin="0 0 0 8"
                disabled={postDetailsMutation.isLoading}
                onClick={() => {
                  dispatch({
                    type: EVENTS.BACK_CLICKED,
                    referenceNumber: values.referenceNumber,
                    amount: values.amount,
                    paymentDate: values.paymentDate,
                  });
                }}
              >
                Back
              </Button>
            </Grid.Item>
          </Grid>
        </Stack>
      )}
    </Form>
  );
}

export { BpayForm };
